<template>
<div id="millia">
<div class="login">
<div class="ht">登录</div>
<ul class="tab">
<li @click="num=0" :class="{active:num==0}">密码登录</li>
<li @click="num=1" :class="{active:num==1}">验证码登录</li>
</ul>
<div class="tabox mt20">
<form class="layui-form" action="" v-show="num==0">
<ul class="userInfo">
<li><input type="text" name="username" lay-verify="required" placeholder="请输入手机号" class="layui-input" v-model="username"></li>
<li><input type="password" name="password" lay-verify="required" placeholder="请输入密码" class="layui-input" v-model="password"></li>
<li><button type="button" class="layui-btn layui-btn-normal layui-btn-fluid" @click="PasswordEnter">登录</button></li>
</ul>
<div class="tc mt20 c999 otherInfo">
<router-link tag="a" to="Regist">账号注册</router-link>
<router-link tag="a" to="PassWord">忘记密码?</router-link>
</div>
</form>
<form class="layui-form" action="" v-show="num==1">
<ul class="userInfo">
<li><input type="text" name="phone" lay-verify="required" autocomplete="off" placeholder="请输入手机号" class="layui-input" v-model="phone"></li>
<li>
<div class="layui-input-inline">
<input type="text" name="code" lay-verify="required" placeholder="请输入验证码" class="layui-input" v-model="code">
</div>
<button type="button" class="layui-btn ml10" @click="GetCode" :disabled="!disabled">{{getCodeTxt}}</button>
</li>
<li><button type="button" class="layui-btn layui-btn-normal layui-btn-fluid" @click="CodeEnter">登录</button></li>
</ul>
<div class="tc mt20 c999 otherInfo">
<router-link tag="a" to="Regist">账号注册</router-link>
<router-link tag="a" to="PassWord">忘记密码?</router-link>
</div>
</form>
</div>
</div>
</div>
</template>
<script>
export default {
  name: 'Login',
  data () {
    return {
      num:0,
      phone:"",
      username:"",
      code:"",
      disabled:true,
      getCodeTxt:"获取验证码",
      password:"",
      user_id:"",
    }
  },
  methods: {
    //获取验证码
    GetCode:function(){
        if(!(/^1[3456789]\d{9}$/.test(this.phone))){
            layer.alert("请输入正确的电话号码");
        }else{
          let url = "api/sms/sendSms";
          let param = {
              type:"login",
              phone:this.phone,
              user_id:this.user_id,
          }
          this.$ajax.get(url,param).then(function (response) {
              if (response.data.status==1) {
                let time = 60;
                let timer = setInterval(() => {
                    if(time == 0) {
                        clearInterval(timer);
                        this.disabled = true;
                        this.getCodeTxt = "获取验证码";
                    } else {
                        this.getCodeTxt =time + '秒后重试';
                        this.disabled = false;
                        time--
                    }
                },1000);
              }else{
                  //alert(response.data.info);
              }
          }.bind(this)).catch(function (err) {
              console.log("连接失败");
          }.bind(this));
        }
    },
    CodeEnter(){
      let url = "api/login/login";
      let params = {
          login_type:2,
          phone:this.phone,
          sms_code:this.code
      }
      this.$ajax.post(url,params).then(function (response) {
          if (response.data.status==1) {
              localStorage.setItem("token5",response.data.data.token);
              localStorage.setItem("userPhoneName",response.data.data.username);
              this.$router.push('/UserInfo');
          }else{
              layer.alert(response.data.info);
          }
      }.bind(this)).catch(function (err) {
          console.log("连接失败");
      }.bind(this));
    },
    PasswordEnter(){
      let url = "api/login/login";
      let params = {
        login_type:1,
        username:this.username,
        password:this.password
      }
      this.$ajax.post(url,params).then(function (response) {
          if (response.data.status==1) {
              localStorage.setItem("token5",response.data.data.token);
              localStorage.setItem("userPhoneName",response.data.data.username);
              this.$router.push('/UserInfo');
          }else{
              layer.alert(response.data.info);
          }
      }.bind(this)).catch(function (err) {
          console.log("连接失败");
      }.bind(this));
    },
  },
  mounted () {
    layui.use('form', function(){
      var form = layui.form;
      //监听提交
      // form.on('submit(formDemo)', function(data){
      //     layer.msg(JSON.stringify(data.field));
      //     return false;
      // });
      form.verify({
          //表单预设元素属性
      });
    });
  }

}
</script>
<style scoped>
#millia{display:flex;justify-content:flex-start;align-items:center;flex-direction:column;height:100%;background:url(../assets/bg.jpg) fixed  #0f7fd1 no-repeat bottom center;background-size:100% auto;}
.tab li{display:inline-block;font-size:1.6rem;line-height:3.8rem;margin:0 1rem;}
.tab li.active{color:darkblue;border-bottom:.3rem solid darkblue;}
.otherInfo a{margin:0 1rem;}
.tabox{width:100%;}
</style>